import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import { sendNotifByToken } from "./api";

function Add(props) {
  // ==================== GET DEFAULTS ==================== //
  const lState = props.location.state;
  const isAddPage = props.match.params.id === undefined;
  // ==================== GET DEFAULTS ==================== //

  // ==================== COMPONENET STATE ==================== //
  const [tokens, settokens] = useState([]);
  const [title, settitle] = useState("");
  const [body, setbody] = useState("");
  const [image, setimage] = useState("");
  const [screen, setscreen] = useState("Interceptor");
  const [store, setstore] = useState("");
  const [url, seturl] = useState("");
  
  const [status, setstatus] = useState(false);
  // ==================== COMPONENET STATE ==================== //

  // ==================== COMPONENT VARIABLES ==================== //
  let buttonText = "Submit";

  switch (status) {
    case "loading":
      buttonText = "Submitting...";
      break;
    case "success":
      buttonText = "Successful";
      break;
    case "error":
      buttonText = "Error";
      break;

    default:
      break;
  }
  // ==================== COMPONENT VARIABLES ==================== //

  return (
    <Wrapper>
      <form id="test-notif">        
        <textarea
          className="field"
          name="tokens"
          placeholder="tokens"
          rows={3}
          value={tokens}
          onChange={(e) => {
            let t = e.target.value;
            if(t.includes(",")){
              t = e.target.value.split(",")
            } else {
              t = [t];
            }
            settokens(t);
          }}
        />
        <input
          className="field"
          name="title"
          placeholder="title"
          value={title}
          onChange={(e) => {
            settitle(e.target.value);
          }}
        />
        <input
          className="field"
          name="body"
          placeholder="body"
          value={body}
          onChange={(e) => {
            setbody(e.target.value);
          }}
        />
        <input
          className="field"
          name="image"
          placeholder="image"
          value={image}
          onChange={(e) => {
            setimage(e.target.value);
          }}
        />        
        <input
          className="field"
          name="screen"
          placeholder="screen"
          value={screen}
          onChange={(e) => {
            setscreen(e.target.value);
          }}
        />
        <input
          className="field"
          name="store"
          placeholder="store"
          value={store}
          onChange={(e) => {
            setstore(e.target.value);
          }}
        />
        <input
          className="field"
          name="url"
          placeholder="url"
          value={url}
          onChange={(e) => {
            seturl(e.target.value);
          }}
        />
        <button
          style={{ marginBottom: "80px" }}
          disabled={!(tokens &&title && body && image && screen && store && url)}
          onClick={async (e) => {
            e.preventDefault();
            let payload = {
              title,
              body,
              image,
              screen,
              store,
              url
            };
            let data = {
              title,
              body,
              image,
              payload: JSON.stringify(payload),
              "click_action": "FLUTTER_NOTIFICATION_CLICK",
            }
                  
            let dataToSend = {
              tokens,
              data
            };
            // document
            //   .querySelector("#test-notif")
            //   .querySelectorAll(".field")
            //   .forEach((e) => {
            //     if(e.name === "tokens"){
            //       let t = e.value;
            //       if(t.includes(",")){
            //         t = e.value.split(",")
            //       } else {
            //         t = [t];
            //       }
            //       body[e.name] = t;
            //     }
            //     else if(["screen", "store", "url"].includes(e.name)){
            //       payload[e.name] = e.value
            //     }
            //     else {
            //       body[e.name] = e.value;
            //     }
            //   });
            setstatus("loading");

            const res = await sendNotifByToken(dataToSend);
            if (res) {
              setstatus("success");
            } else {
              setstatus("error");
            }
          }}
        >
          {buttonText}
        </button>
      </form>
    </Wrapper>
  );
}

export default withRouter(Add);
// "name": "Amazon",
// "description": "Amazon.in: Online Shopping India - Buy mobiles, laptops, cameras, books, watches, apparel, shoes and e-Gift Cards. Free Shipping & Cash on Delivery Available.",
// "domain": "amazon",
// "URL": "https://www.amazon.in",
// "logo": "logo",
// "dSelectors": {"title":{"css":"h1.prod-name","type":"Text"},"price":{"css":"div.prod-sp","type":"Text"},"brand":{"css":"h2.brand-name","type":"Text"},"offers":{"css":"div.promo-blck","multiple":true,"type":"Text"},"size_instock":{"css":"div.size-instock","multiple":true,"type":"Text"},"size_outofstock":{"css":"div.swatch-size-oos","multiple":true,"type":"Text"},"details":{"css":"li.detail-list","multiple":true,"type":"Text"},"image":{"css":"img.rilrtl-lazy-img","type":"Attribute","attribute":"src"}},
// "mSelectors": {"title": { "css": "span[id=productTitle]", "type": "Text" },"price": [{ "css": "span[id=priceblock_ourprice]", "type": "Text" },{ "css": "span[id=priceblock_saleprice]", "type": "Text" },{ "css": "span[id=priceblock_dealprice]", "type": "Text" }],"tags": {"css": "div.a-breadcrumb a.a-link-normal","multiple": true,"type": "Text"},"description": {"css": "ul.a-unordered-list.a-spacing-mini li span.a-list-item","multiple": true,"type": "Text"},"image": {"css": "img[id=landingImage]","multiple": true,"type": "Attribute","attribute": "src"},"offers": {"css": "ul.a-unordered-list.a-spacing-small > li span.a-list-item","multiple": true,"type": "Text"}}
